import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StringUtils } from 'ats-ui-lib';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CepProviderService } from './cep-provider.service';

export interface City {
  id: string;
  name: string;
}

export interface Address {
  cityName: string;
  cityId: string;
  neighborhood: string | null;
  stateName: string;
  stateId: string;
  street: string | null;
}

export interface LocalityState {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class CepService {
  constructor(
    private http: HttpClient,
    private cepProvider: CepProviderService,
  ) {}

  private async getStateBySmallName(smallName: string): Promise<LocalityState> {
    const state = await lastValueFrom(
      this.http.get<LocalityState>(
        `${environment.applicantApiEndpoint}/localities/states/small-name/${smallName}`,
      ),
    );

    return state;
  }

  private async getCityFromStateByName(id: string, name: string): Promise<City> {
    const city = await lastValueFrom(
      this.http.get<LocalityState>(
        `${environment.applicantApiEndpoint}/localities/state/${id}/city/name/${name}`,
      ),
    );
    return city;
  }

  async getAddressByCep(cepString: string): Promise<Address | null> {
    try {
      const cep = this.cepProvider.getCepFunction();
      const internalAddress = await cep(cepString, {});
      const state = await this.getStateBySmallName(internalAddress.state);
      const city = await this.getCityFromStateByName(state.id, internalAddress.city);
      return {
        cityName: city.name,
        cityId: city.id,
        neighborhood: StringUtils.coalesceWhitespaceToNull(internalAddress.neighborhood),
        stateName: state.name,
        stateId: state.id,
        street: StringUtils.coalesceWhitespaceToNull(internalAddress.street),
      };
    } catch (error) {
      return null;
    }
  }
}
